"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageHeader = /** @class */ (function () {
    function PageHeader(height, ngZone, cd) {
        this.height = height;
        this.ngZone = ngZone;
        this.cd = cd;
        this.transition = 0;
    }
    PageHeader.prototype.scroll = function (scrollBy) {
        var _this = this;
        var possibleTransition = this.transition - scrollBy;
        possibleTransition = this.correctTransition(possibleTransition);
        if (this.ngZone) {
            this.transition = this.ngZone.run(function () {
                var oldValue = _this.transition;
                var changed = oldValue !== possibleTransition;
                _this.transition = possibleTransition;
                if (changed && _this.cd) {
                    _this.cd.detectChanges();
                }
                return possibleTransition;
            });
        }
        else {
            this.transition = possibleTransition;
        }
    };
    PageHeader.prototype.correctTransition = function (possibleTransition) {
        var transitionMin = this.height * -1;
        if (possibleTransition < transitionMin) {
            possibleTransition = transitionMin;
        }
        else if (possibleTransition > 0) {
            possibleTransition = 0;
        }
        return possibleTransition;
    };
    PageHeader.EMPTY = new PageHeader(0, undefined);
    return PageHeader;
}());
exports.PageHeader = PageHeader;
//# sourceMappingURL=page-header.js.map